import React from 'react';
import { ContextualMenu as FluentContextualMenu, initializeIcons, IContextualMenuProps } from '@fluentui/react';

initializeIcons();

const ContextualMenuDropdown: React.FC<IContextualMenuProps> = props => <FluentContextualMenu {...props} />;

export * from '@fluentui/react';
export { ContextualMenuDropdown as ContextualMenu };
